<markant-platform-guided-tour-wrapper
  [guidedTourSteps]="steps"
  [onBack]="backButtonCallback"
  [onNext]="nextButtonCallback"
  [currentStep]="currentStep"
  [enableClickThrough]="enableClickThrough"
></markant-platform-guided-tour-wrapper>

@if (showHighlightDialog$ | async; as dialogConfig) {
  <markant-platform-guided-tour-highlight-dialog
    [currentStep]="currentStep"
    [dialogPosition]="dialogConfig.position"
    [viewSize]="dialogConfig.viewSize"
    [stepsWithPreviousButton]="[11]"
    targetId="my-employees-tour-highlight-dialog"
    textBaseKey="guidedTour.tours.guided-tour-oa-admin-area.section3"
    (next)="nextTarget()"
    (previous)="previousTarget()"
  >
    <markant-platform-organization-member-detail-demo
      [currentStep]="currentStep"
    ></markant-platform-organization-member-detail-demo>
  </markant-platform-guided-tour-highlight-dialog>
}
